module.exports = __webpack_public_path__ + "static/media/bussiness1.4448c9e1.png";